var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 348,
    viewBox: "20,415.3 84.4 29.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SBB CFF FFS logo notext") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 416,
    width: 83,
    height: 28,
    fill: "#de0023"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 62.3,430 L 71.4,420.8 H 77.2 L 71,427.6 78.7,427.4 78.9,420.8 H 83.7 L 83.9,427.4 91.6,427.6 85.4,420.8 H 91.2 L 100.3,430 91.2,439.2 H 85.4 L 91.6,432.4 83.9,432.6 83.7,439.2 H 78.9 L 78.7,432.6 71,432.4 77.2,439.2 H 71.4 Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCff);
export default __webpack_public_path__ + "static/media/cff.c6c8407250d2466aaf331f2fb4a59ae9.svg";
export { ForwardRef as ReactComponent };